import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Header.css";
import { LogIn, LogOut, Menu } from "lucide-react";

const formatTime = (date, timeZone) =>
  new Intl.DateTimeFormat("en-GB", {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);

const Header = ({ onToggleSidebar }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [fullName, setFullName] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [now, setNow] = useState(new Date());
  const navigate = useNavigate();

  // Header clock — ticks every second
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Check login status on component load (using access_token presence)
  useEffect(() => {
    const tokenPresent = !!localStorage.getItem("access_token");
    setIsLoggedIn(tokenPresent);
    setFullName(localStorage.getItem("full_name") || "");
  }, []);

  // Handle window resize to update isMobile state
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("role");
    localStorage.removeItem("permissions");
    localStorage.removeItem("is_superuser");
    localStorage.removeItem("all_role_codes");
    localStorage.removeItem("full_name");
    setIsLoggedIn(false);
    setFullName("");
    navigate("/LoginPage");
  };

  return (
    <header style={{ height: "74px" }}>
      <div className="header-content d-flex align-items-center h-100">
        <button
          type="button"
          className="mobile-menu-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <Menu size={22} color="#333" />
        </button>
        {/* Logos */}
        <div className="d-flex align-items-center gap-1">
          <img
            src="/timor.png"
            alt="Timor Logo"
            className="logo"
            style={{marginRight: "5px" }}
          />
          <img
            src="/dnmg1.png"
            alt="Meteorology Logo"
            className="logo1"
          />
           <img
            src="/DNMG_NEW.png"
            alt="Meteorology Logo"
            className="logo1"
          />
        </div>
        {/* Text */}
        <div className="text-container ms-3">
          <span className="bold-text">
            {isMobile
              ? <>
      Disaster Risk Reduction <br />
      Decision Support System
    </>
              : "Disaster Risk Reduction Decision Support System"}
          </span>
          <span className="header-text">
            National Directorate of Meteorology and Geophysics - Timor Leste
          </span>
        </div>
      </div>

      <div className="icon-container">
        <div className="user-icon-wrapper" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div className="header-clock" aria-label="Current time in UTC and Timor-Leste">
            <span className="clock-row">
              <span className="clock-zone">UTC</span>
              <span className="clock-time">{formatTime(now, "UTC")}</span>
            </span>
            <span className="clock-row">
              <span className="clock-zone">Timor</span>
              <span className="clock-time">{formatTime(now, "Asia/Dili")}</span>
            </span>
          </div>
          {isLoggedIn ? (
            <>
              <span className="header-user-name">{fullName || "User"}</span>

              <button
                className="loginlogout"
                onClick={handleLogout}
                aria-label="Logout from the system"
              >
                <LogOut size={16} color="#000" />
                <span className="login-logout">
                  Logout
                </span>
              </button>
            </>
          ) : (
            <button
              className="loginlogout"
              onClick={() => navigate("/LoginPage")}
              aria-label="Login to the system"
            >
              <span className="login-logout">
                  Login
                </span>
              <LogIn size={16} color="#000" />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;

